<div
  #selectComponent
  [id]="buttonId"
  class="select"
  aria-label="tag select"
  [class.select__single-line]="ppOptions.singleLineInput"
  [class]="ppClass"
  [class.select--disabled]="ppOptions.disabled"
  [class.select--inputFocused]="focused && !ppOptions.noBorder"
  [class.select--error]="ppOptions.hasError"
  [class.select--noBorder]="ppOptions.noBorder"
  [class.select--caret]="showSelectCaret()"
  (click)="toggleDropdown()"
>
  <div #selectContent class="select__content">
    <ng-container selected class="select__content--wrapper">
      <div class="select__content--wrapper" datat-test="filterTagsList">
        @if (!ppOptions.disabled && ppOptions.showIcon) {
          <img [src]="EIconPath.BASIC_FIELD_TAGS" class="tagSelect__tag-icon icon-gap--right2x" />
        }

        @if (ppOptions.combinedTags && selectedTags.length > 0) {
          <pp-tag
            [ppText]="selectedTags.join(', ')"
            [ppDeletable]="true"
            (ppDelete)="clearAll()"
          ></pp-tag>
        }

        @if (!ppOptions.combinedTags) {
          @for (tag of selectedTags; track tag; let i = $index) {
            <pp-tag
              [ppText]="tag"
              [ppDisabled]="ppOptions.disabled || ppReadOnlyTags.includes(tag)"
              [ppDeletable]="
                !ppOptions.disabled &&
                !ppReadOnlyTags.includes(tag) &&
                (!ppOptions.tagsLimited || selectedTags.length > 1)
              "
              (ppDelete)="removeSelectedTag(i)"
            ></pp-tag>
          }
        }

        @if (showPlaceholder()) {
          <p class="placeholder-text" [class.tagSelect__placeholder--noFaint]="ppPlaceholder">
            {{ placeholder }}
          </p>
        }
      </div>
    </ng-container>
  </div>

  @if (!ppOptions.disabled) {
    @if (ppOptions.showSaveIndicator) {
      <pp-save-indicator
        [ppFocused]="focused"
        [ppFilled]="selectedTags.length > 0"
        [ppShowClearBtn]="ppOptions.showClearBtn"
        [ppUpdating]="ppOptions.showUpdateIndicator"
        (ppAction)="clearAll()"
      ></pp-save-indicator>
    }
    @if (showSelectCaret()) {
      <div class="select__caret">
        <div class="select__icon-container">
          <pp-icon
            [ppSrc]="
              dropdown.visible && dropdown.buttonId === buttonId
                ? EIconPath.ICON_MISC_UP_ARROW_18
                : EIconPath.ICON_MISC_DOWN_ARROW_18
            "
            ppColor="grey-400"
            ppClass="setSize18"
          ></pp-icon>
        </div>
      </div>
    }
  }
</div>
